import { render } from "./QuestionTabs.vue?vue&type=template&id=0d51f297&scoped=true"
import script from "./QuestionTabs.vue?vue&type=script&lang=js"
export * from "./QuestionTabs.vue?vue&type=script&lang=js"

import "./QuestionTabs.vue?vue&type=style&index=0&id=0d51f297&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d51f297"]])

export default __exports__